import React, { useContext } from 'react';
import { TranslationKey } from '../../../../../../../../types/translation/TranslationKey';
import { ProductTransaction, ProductTransactionType } from '../../../../../../../../types/productTransaction';
import { Grid } from '@mui/material';
import { ProductMasterData } from '../../../../../../../../types/product_master_data/productMasterData';
import { t } from '../../../../../../../../types/translation/Translator';
import { ProductContext } from '../../../../../../../../context/ProductContext';
import { Container } from '../../../../../../../../types/container';
import { DropdownSearchSelect } from '../../../../../../../components/Dropdown';

interface ProductTransactionSourceLPNProps {
  transaction: ProductTransaction;
  setTransaction: React.Dispatch<React.SetStateAction<ProductTransaction>>;
  productMasterData?: ProductMasterData;
  container?: Container;
  disabled?: boolean;
}

export default function ProductTransactionSourceLPN({
  transaction,
  setTransaction,
  productMasterData,
  container,
  disabled = false,
}: ProductTransactionSourceLPNProps) {
  if (!productMasterData) return null;

  const { products } = useContext(ProductContext);

  if (!productMasterData.lpnManaged) return null;
  if (transaction.type === ProductTransactionType.inbound) return null;

  const lpnProducts = [...(products.get(transaction.product.pmdId || '')?.values() || [])].filter(
    el =>
      el.lpn &&
      el.companyId === transaction.companyId &&
      (!transaction.product.fromStockLocationId || el.stockLocationId === transaction.product.fromStockLocationId) &&
      (!transaction.product.fromBinId || el.binId === transaction.product.fromBinId),
  );

  const selected = lpnProducts.find(p => p.lpn === transaction.product.lpn) || undefined;

  return (
    <Grid item xs={6}>
      <DropdownSearchSelect
        mandatory
        disabled={disabled}
        label={t(TranslationKey.lpn).singular.label}
        placeholder={t(TranslationKey.lpn).singular.label}
        items={lpnProducts}
        textBuilder={product => product?.lpn || ''}
        value={selected}
        onSelect={product => {
          const updated = transaction.withLPN(product?.lpn).withSerial(product?.serial);
          if (product) updated.withFromBinId(product.binId).withFromContainerId(product.containerId);
          setTransaction(updated);
        }}
      />
    </Grid>
  );
}
